export default __webpack_public_path__ + "static/media/ref_image_2.86d864cb.svg";